import { Typography } from '@sravni/react-design-system';

import type { CellContext } from '@tanstack/table-core';

import type { ProductRatingItem } from '../../../types/rating';

import styles from './columns.module.scss';

export const makeProductTermColumn = (key: string) => (info: CellContext<ProductRatingItem, any>) => {
  const { termsByKey } = info.row.original;

  const value = (termsByKey[key]?.value as string)?.replace('на срок', '');

  return (
    <Typography.Text size={14} className={styles.commonColumn}>
      {value}
    </Typography.Text>
  );
};
